import React from 'react'

import KartVisning from './kart'
import Repository from '../repository'

export default class kartContainer extends React.Component {

    constructor(props) {
        super(props)

        this._repository = new Repository()
        this.state = {
            vannmaalere: [],                        
            tittel: '',
            beskrivelse: '',
        }

        this._hentArbeidsliste = this._hentArbeidsliste.bind(this)
        this._onDataMotatt = this._onDataMotatt.bind(this)
        this._navigerTilSkiftMaaler = this._navigerTilSkiftMaaler.bind(this)
    }

    componentDidMount() {
        this._hentArbeidsliste().then(this._onDataMotatt)
    }

    _hentArbeidsliste() {        
        return this._repository.hentArbeidslisteMedId(this.props.id)
    }

    _onDataMotatt(liste) {
        let arbliste = liste
       
        this.setState({
            vannmaalere: arbliste.VannmaalerePlanlegging,            
            tittel: arbliste.Tittel,
            beskrivelse: arbliste.Beskrivelse,     
                           
        })
    }

    _navigerTilSkiftMaaler(maalerId){
        this.props.history.push('/utskiftning/'+this.props.id+"/vannmaaler/"+maalerId)
    }

    render() {                
        return (
            <KartVisning vannmaalere={this.state.vannmaalere} tittel={this.state.tittel} beskrivelse={this.state.beskrivelse} 
            onClose={this.props.onClose} navigerTilSkiftMaaler={this._navigerTilSkiftMaaler} viseKnappForMaalerskifte={this.props.skalviseMaalerskfteKnapp}/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/felles/Kart/kartContainer.jsx